<template>
  <div class="rn-gallery-area gallery-area rn-section-gap" id="homegallery"
    v-if="NOTARIA && NOTARIA.Theme && NOTARIA.Theme.Home.Gallery.Mostrar">
    <v-container>
      <div>
        <v-row>
          <v-col sm="12" cols="12">
            <div class="banner-home-gallery-notin section-title-notin content">
              <h2 class="heading-title" v-html="NOTARIA.Theme.Home.Gallery.Titulo.Texto"></h2>
              <p v-html="NOTARIA.Theme.Home.Gallery.Descripcion.Texto">
              </p>
            </div>
          </v-col>
        </v-row>
      </div>
      <!-- Skeleton Loader Area -->
      <v-row v-if="store.loading" class="mt--30">
        <v-col cols="12" sm="6" :md="comNumColumnas" v-for="n in (Number(NOTARIA.Theme.Home.Gallery.TotalImagenes) || 4)" :key="'gallery-skel-' + n" class="d-flex child-flex py-4">
          <v-skeleton-loader
            type="image"
            height="300"
            width="100%"
            :color="style.ThemeGeneral?.TextoCss?.Color ? style.ThemeGeneral.TextoCss.Color + '10' : 'rgba(0,0,0,0.05)'"
            class="rounded-lg"
          ></v-skeleton-loader>
        </v-col>
      </v-row>

      <div
        v-if="isCarrusel && !store.loading"
        class="mt--10 custom-marquee-container"
      >
        <div class="custom-marquee-content">
          <!-- First set -->
          <div
            v-for="(archivo, index) in compArchivos"
            :key="'set1-' + (archivo.id || index)"
            class="custom-marquee-item py-4"
            :style="marqueeItemStyle"
          >
            <div
              class="modern-gallery-card d-flex flex-column fill-height w-100"
              @click="openLightbox(index)"
            >
              <div class="modern-image-container relative overflow-hidden">
                <v-img
                  v-if="archivo.id && archivo.showInGallerySection"
                  :src="imagenIDtoSRC(archivo.id)"
                  aspect-ratio="1"
                  class="modern-gallery-image"
                  cover
                  :alt="'Imagen ' + (index + 1) + ' - ' + NOTARIA.Nombre + ' - Galería'"
                />
                <div class="modern-gallery-overlay d-flex align-center justify-center">
                  <div class="zoom-icon-wrapper d-flex align-center justify-center">
                    <v-icon large color="primary">mdi-magnify-plus-outline</v-icon>
                  </div>
                </div>
              </div>
              <div
                v-if="NOTARIA.Theme.Home.Gallery.MostrarDescripcion && archivo.Description"
                class="modern-gallery-content pa-5 d-flex flex-column flex-grow-1"
              >
                <p
                  class="modern-gallery-description flex-grow-1 mb-0"
                  v-html="archivo.Description.replace(/(?:\r\n|\r|\n)/g, '<br>')"
                ></p>
              </div>
            </div>
          </div>
          <!-- Second set -->
          <div
            v-for="(archivo, index) in compArchivos"
            :key="'set2-' + (archivo.id || index)"
            class="custom-marquee-item py-4"
            :style="marqueeItemStyle"
          >
            <div
              class="modern-gallery-card d-flex flex-column fill-height w-100"
              @click="openLightbox(index)"
            >
              <div class="modern-image-container relative overflow-hidden">
                <v-img
                  v-if="archivo.id && archivo.showInGallerySection"
                  :src="imagenIDtoSRC(archivo.id)"
                  aspect-ratio="1"
                  class="modern-gallery-image"
                  cover
                  :alt="'Imagen ' + (index + 1) + ' - ' + NOTARIA.Nombre + ' - Galería'"
                />
                <div class="modern-gallery-overlay d-flex align-center justify-center">
                  <div class="zoom-icon-wrapper d-flex align-center justify-center">
                    <v-icon large color="primary">mdi-magnify-plus-outline</v-icon>
                  </div>
                </div>
              </div>
              <div
                v-if="NOTARIA.Theme.Home.Gallery.MostrarDescripcion && archivo.Description"
                class="modern-gallery-content pa-5 d-flex flex-column flex-grow-1"
              >
                <p
                  class="modern-gallery-description flex-grow-1 mb-0"
                  v-html="archivo.Description.replace(/(?:\r\n|\r|\n)/g, '<br>')"
                ></p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <v-row v-else-if="isModerno && !store.loading" class="row-gap-30 mt--10">
        <v-col
          cols="12"
          sm="6"
          :md="comNumColumnas"
          v-for="(archivo, index) in compArchivos"
          :key="archivo.id || index"
          class="d-flex py-4"
        >
          <div
            class="modern-gallery-card d-flex flex-column fill-height w-100"
            @click="openLightbox(index)"
          >
            <!-- Image Container with zoom effect and overlay -->
            <div class="modern-image-container relative overflow-hidden">
              <v-img
                v-if="archivo.id && archivo.showInGallerySection"
                :src="imagenIDtoSRC(archivo.id)"
                aspect-ratio="1"
                class="modern-gallery-image"
                cover
                :alt="'Imagen ' + (index + 1) + ' - ' + NOTARIA.Nombre + ' - Galería'"
              />
              <!-- Hover overlay with a zoom icon -->
              <div class="modern-gallery-overlay d-flex align-center justify-center">
                <div class="zoom-icon-wrapper d-flex align-center justify-center">
                  <v-icon large color="primary">mdi-magnify-plus-outline</v-icon>
                </div>
              </div>
            </div>

            <!-- Description block outside image with clean borders, if enabled -->
            <div
              v-if="NOTARIA.Theme.Home.Gallery.MostrarDescripcion && archivo.Description"
              class="modern-gallery-content pa-5 d-flex flex-column flex-grow-1"
            >
              <p
                class="modern-gallery-description flex-grow-1 mb-0"
                v-html="archivo.Description.replace(/(?:\r\n|\r|\n)/g, '<br>')"
              ></p>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-row class="mt--30" v-else-if="!store.loading">
        <!-- Start Single Gallery Area  -->
        <v-col cols="12" sm="6" :md="comNumColumnas" v-for="(archivo, index) in compArchivos" :key="archivo.id" class="d-flex child-flex py-4">
          <!-- <div class="thumbnail" v-if="archivo.id && archivo.showInGallerySection"> -->
             <v-row class="mx-1" style="cursor: pointer;" @click="openLightbox(index)">
               <v-img 
                v-if="archivo.id && archivo.showInGallerySection" 
                :src="imagenIDtoSRC(archivo.id)" 
                aspect-ratio="1" 
                class="bg-grey-lighten-2" 
                cover 
                :alt="'Imagen ' + (index + 1) + ' - ' + NOTARIA.Nombre + ' - Galería'"
               />
                <div v-if="NOTARIA.Theme.Home.Gallery.MostrarDescripcion && archivo.Description" >
                  <p class="gallery-description" v-html="archivo.Description.replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                </div>  
            </v-row>
            
          <!-- </div> -->
        </v-col>
        <!-- End Single Gallery Area  -->
      </v-row>
    </v-container>
    <GalleryLightbox v-model="lightboxDialog" :images="lightboxImages" :initialIndex="lightboxIndex" />
  </div>
</template>

<script setup>
import { useStore } from '../../store/index.ts'
const store = useStore()
const { NOTARIA, ARCHIVOS_COMUNES } = storeToRefs(store)
import { useUtils } from '#imports';
const { imagenIDtoSRC, $t } = useUtils()

import { useStyles } from '../../store/styles';
const style = useStyles();

const control = style.ThemeHomeGallery

const lightboxDialog = ref(false)
const lightboxIndex = ref(0)
const lightboxImages = computed(() => {
  return compArchivos.value.map(a => ({ src: imagenIDtoSRC(a.id) }))
})

const openLightbox = (index) => {
  lightboxIndex.value = index
  lightboxDialog.value = true
}

const compArchivos = computed(() => {
  const source = (ARCHIVOS_COMUNES.value && ARCHIVOS_COMUNES.value.length > 0)
    ? ARCHIVOS_COMUNES.value
    : (NOTARIA.value?.Archivos || []);
  let filtered = source.filter(a => a.showInGallerySection);
  return filtered.sort((a, b) => (Number(a.Orden) || 9999) - (Number(b.Orden) || 9999));
})
const comNumColumnas = computed(() => {
  if (NOTARIA.value?.Theme.Home.Gallery.NumeroColumnas == 1) {
    return 12
  } else if (NOTARIA.value?.Theme.Home.Gallery.NumeroColumnas == 2) {
    return 6
  } else if (NOTARIA.value?.Theme.Home.Gallery.NumeroColumnas == 3) {
    return 4
  } else if (NOTARIA.value?.Theme.Home.Gallery.NumeroColumnas == 4) {
    return 3
  }
})
const isModerno = computed(() => {
  return NOTARIA.value?.Theme?.Home?.Gallery?.Tipo === 'moderno';
})
const isCarrusel = computed(() => {
  return NOTARIA.value?.Theme?.Home?.Gallery?.Tipo === 'carrusel';
})
const marqueeItemStyle = computed(() => {
  // Forzamos 25vw para que ocupen toda la pantalla y se vean exactamente 4 fotos a la vez, haciéndolas más grandes.
  return `width: calc(25vw - 30px); margin: 0 15px; flex-shrink: 0;`;
})

const estiloTituloColor = ref(control.Titulo?.css?.Color ? control.Titulo.css.Color : "inherit")
// const estiloTituloBackgroundColor = control.Titulo.css.BackgroundColor
const estiloTituloShadow = ref(control.Titulo?.css.BackgroundColor ? "4px 2px 6px "+control.Titulo.css.BackgroundColor:"inherit")
const estiloTituloFont = ref(control.Titulo?.css?.Font ? control.Titulo.css.Font : "inherit")
const estiloTituloSize = ref(control.Titulo?.css?.Size ? control.Titulo.css.Size : "inherit")
const estiloTituloWeight = ref(control.Titulo?.css?.Weight ? control.Titulo.css.Weight : "inherit")
const estiloTituloAlign = ref(control.Titulo?.css?.Align ? control.Titulo.css.Align : "inherit")

const estiloDescripcionColor = ref(control.Descripcion?.css?.Color ? control.Descripcion.css.Color: "inherit")
// const estiloDescripcionBackgroundColor = control.Descripcion.css.BackgroundColor
const estiloDescripcionShadow = ref(control.Descripcion?.css?.BackgroundColor ? "4px 2px 6px "+ control.Descripcion.css.BackgroundColor : "inherit")
const estiloDescripcionFont = ref(control.Descripcion?.css?.Font ? control.Descripcion.css.Font: "inherit")
const estiloDescripcionSize = ref(control.Descripcion?.css?.Size ? control.Descripcion.css.Size: "inherit")
const estiloDescripcionWeight = ref(control.Descripcion?.css?.Weight ? control.Descripcion.css.Weight: "inherit")
const estiloDescripcionAlign = ref(control.Descripcion?.css?.Align ? control.Descripcion.css.Align: "inherit")

const descriptionColor = ref(control.DescriptionCss?.Color ? control.DescriptionCss.Color : "inherit")
const descriptionShadow = ref(control.DescriptionCss?.BackgroundColor ? "4px 2px 6px "+ control.DescriptionCss.BackgroundColor : "inherit")
const descriptionFont = ref(control.DescriptionCss?.Font ? control.DescriptionCss.Font : "inherit")
const descriptionSize = ref(control.DescriptionCss?.Size ? control.DescriptionCss.Size : "inherit")
const descriptionWeight = ref(control.DescriptionCss?.Weight ? control.DescriptionCss.Weight : "inherit")
const descriptionAlign = ref(control.DescriptionCss?.Align ? control.DescriptionCss.Align : "inherit")
</script>

<style lang="scss" scoped>
.gallery-description {
  color:v-bind(descriptionColor) !important;
  text-shadow:v-bind(descriptionShadow)  !important;
  font-size:v-bind(descriptionSize) !important;
  font-family: v-bind(descriptionFont) !important;
  font-weight:v-bind(descriptionWeight) !important;
  text-align:v-bind(descriptionAlign)  !important;
}
.banner-home-gallery-notin.section-title-notin
{
  h2.heading-title {
    color:v-bind(estiloTituloColor) ;
    text-shadow:v-bind(estiloTituloShadow)  ;
    font-family:v-bind(estiloTituloFont)  ;
    font-size:v-bind(estiloTituloSize) ;
    font-weight:v-bind(estiloTituloWeight) ;
    text-align:v-bind(estiloTituloAlign)  ;
  }
      
}
.section-title-notin p
{
  color:v-bind(estiloDescripcionColor) !important;
  text-shadow:v-bind(estiloDescripcionShadow)  !important;
  font-family:v-bind(estiloDescripcionFont)  !important;
  font-size:v-bind(estiloDescripcionSize)  !important;
  font-weight:v-bind(estiloDescripcionWeight)  !important;
  text-align:v-bind(estiloDescripcionAlign)  !important;
}
    
.v-img{
  width: 100%;
}

/* Modern Gallery Premium Styles */
.modern-gallery-card {
  position: relative;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  cursor: pointer;
  z-index: 1;

  .modern-image-container {
    position: relative;
    width: 100%;
    overflow: hidden;
    border-radius: 20px 20px 0 0;
    
    &:last-child {
      border-radius: 20px;
    }

    .modern-gallery-image {
      transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1) !important;
    }

    .modern-gallery-overlay {
      position: absolute;
      inset: 0;
      background: rgba(57, 73, 171, 0.35);
      opacity: 0;
      backdrop-filter: blur(4px);
      transition: all 0.4s ease;
      z-index: 2;

      .zoom-icon-wrapper {
        width: 56px;
        height: 56px;
        background: rgba(255, 255, 255, 0.25);
        border: 1px solid rgba(255, 255, 255, 0.4);
        border-radius: 50%;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
        transform: scale(0.8);
        transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
      }
    }
  }

  .modern-gallery-content {
    background: #ffffff;
    border-top: 1px solid rgba(0, 0, 0, 0.03);
    
    .modern-gallery-description {
      color: v-bind(descriptionColor) !important;
      text-shadow: v-bind(descriptionShadow) !important;
      font-size: v-bind(descriptionSize) !important;
      font-family: v-bind(descriptionFont) !important;
      font-weight: v-bind(descriptionWeight) !important;
      text-align: v-bind(descriptionAlign) !important;
      line-height: 1.5;
    }
  }

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
    border-color: rgba(0, 0, 0, 0.1);

    .modern-gallery-image {
      transform: scale(1.08) !important;
    }

    .modern-gallery-overlay {
      opacity: 1;

      .zoom-icon-wrapper {
        transform: scale(1);
        background: rgba(255, 255, 255, 0.9);
        color: #3949ab !important;
        
        ::v-deep .v-icon {
          color: #3949ab !important;
        }
      }
    }
  }
}

.custom-marquee-container {
  overflow: hidden;
  white-space: nowrap;
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  padding: 20px 0;
}

.custom-marquee-content {
  display: inline-flex;
  animation: scroll-marquee 120s linear infinite;
}

.custom-marquee-content:hover {
  animation-play-state: paused;
}

.custom-marquee-item {
  white-space: normal;
}

@keyframes scroll-marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@media (max-width: 600px) {
  .modern-gallery-card {
    border-radius: 16px;
    
    .modern-image-container {
      border-radius: 16px 16px 0 0;
      
      &:last-child {
        border-radius: 16px;
      }
    }
  }
}
</style>